import { Divider as MuiDivider, SxProps } from "@mui/material";

const Divider = ({ sx }: { sx?: SxProps }) => {
  return (
    <MuiDivider sx={{ height: "1px", color: "divider", my: "8px", ...sx }} />
  );
};

export default Divider;
